import React from 'react';
import { CusProductListGenderSectionProps } from '../../cus-product-list.data';

export default function GenderSection({
    availableGenders,
    selectedGender,
    onSelectionChange,
    genderFilterHeading,
    searchGenderFemaleText,
    searchGenderMaleText
}: CusProductListGenderSectionProps) {
    const [isCollapsed, setIsCollapsed] = React.useState(false);

    return (
        <section className='bs-product-list-filters__section'>
            <button
                type='button'
                className='bs-product-list-filters__section__title'
                onClick={() => setIsCollapsed(prev => !prev)}
                aria-expanded={!isCollapsed}
            >
                {genderFilterHeading}
                <span className='bs-product-list-filters__section__title__chevron' aria-hidden='true' />
            </button>
            <div
                className={`bs-product-list-filters__gender${isCollapsed ? ' --collapsed' : ''}`}
                role='group'
                aria-label={genderFilterHeading}
            >
                {availableGenders.map(option => (
                    <button
                        key={option}
                        type='button'
                        className={`bs-product-list-filters__gender__btn${selectedGender === option ? ' --selected' : ''}`}
                        aria-pressed={selectedGender === option}
                        onClick={() => onSelectionChange(selectedGender === option ? undefined : option)}
                        data-testid={`plp-gender-${option}`}
                    >
                        {option === 'female' ? searchGenderFemaleText : searchGenderMaleText}
                    </button>
                ))}
            </div>
        </section>
    );
}
